/* eslint-disable react/prefer-stateless-function */

import React from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalBody } from '@99designs/common/components/Modal';
import { Button } from '@99designs/common/components/Button';
import { ButtonGroup, ButtonGroupItem } from '@99designs/common/components/ButtonGroup';
import { FormattedMessage } from 'react-intl';

export default class SuccessfulInviteModal extends React.Component {
    contestTitleLink() {
        return (
            <a className="link" href={this.props.contest.url}>
                {this.props.contest.title}
            </a>
        );
    }
    render() {
        return (
            <Modal
                variations={['wide', 'medium']}
                isConfirmation={false}
                isActive={this.props.isActive}
                onClose={this.props.onClose}
            >
                <ModalBody>
                    <h3 className="success-modal__heading success-modal__heading--with-divider">
                        <FormattedMessage id="invite_sent" />
                    </h3>
                    <p className="success-modal__description">
                        <FormattedMessage
                            id="invite_sent_details"
                            values={{
                                contest_title: this.contestTitleLink(),
                            }}
                        />
                    </p>
                    <ButtonGroup variations={['responsive']}>
                        <ButtonGroupItem>
                            <Button
                                href={this.props.findDesignersUrl}
                                onClick={this.props.onClose}
                                variations={['primary']}
                            >
                                <FormattedMessage id="discover_new" />
                            </Button>
                        </ButtonGroupItem>
                        <ButtonGroupItem>
                            <Button
                                href={this.props.favoriteDesignersUrl}
                                onClick={this.props.onClose}
                                variations={['secondary']}
                            >
                                <FormattedMessage id="see_favorite_designers" />
                            </Button>
                        </ButtonGroupItem>
                    </ButtonGroup>
                </ModalBody>
            </Modal>
        );
    }
}

SuccessfulInviteModal.propTypes = {
    favoriteDesignersUrl: PropTypes.string.isRequired,
    findDesignersUrl: PropTypes.string.isRequired,
    onClose: PropTypes.func.isRequired,
    isActive: PropTypes.bool.isRequired,
    contest: PropTypes.shape({
        id: PropTypes.number.isRequired,
        title: PropTypes.string.isRequired,
        url: PropTypes.string.isRequired,
    }).isRequired,
};



// WEBPACK FOOTER //
// ./src/js/apps/invite-designer/components/SuccessfulInviteModal.jsx